// extracted by mini-css-extract-plugin
export default {"logAs":"styles_logAs__TUdrf","logAsOpened":"styles_logAsOpened__+LKHW","logAsIcon":"styles_logAsIcon__4XCrI"};